import type { ExperimentResponse } from "../types";
import { Experiments } from "./experimentsList";

/**
 * Generates a fallback ExperimentResponse when LaunchDarkly fails
 *
 * Matches the current production LaunchDarkly configuration as of April 28, 2026
 */
export const getFallbackExperimentResponse = (): ExperimentResponse => ({
  experiments: [
    {
      id: Experiments.HOMES.name,
      variant: Experiments.HOMES.variants.available,
    },
    {
      id: Experiments.HEADER_FOOTER.name,
      variant: Experiments.HEADER_FOOTER.variants.available,
    },
    {
      id: Experiments.AI_ASSIST_COPY_CONVERSATION_ID.name,
      variant: Experiments.AI_ASSIST_COPY_CONVERSATION_ID.variants.available,
    },
    {
      id: Experiments.DISABLE_REWARDS_PAYMENT.name,
      variant: Experiments.DISABLE_REWARDS_PAYMENT.variants.control,
    },
    {
      id: Experiments.FLIGHTS_ENABLED.name,
      variant: Experiments.FLIGHTS_ENABLED.variants.available,
    },
    {
      id: Experiments.STAYS_ENABLED.name,
      variant: Experiments.STAYS_ENABLED.variants.available,
    },
    {
      id: Experiments.CARS_ENABLED.name,
      variant: Experiments.CARS_ENABLED.variants.available,
    },
    {
      id: Experiments.ACTIVITIES_ENABLED.name,
      variant: Experiments.ACTIVITIES_ENABLED.variants.available,
    },
    {
      id: Experiments.PACKAGES_ENABLED.name,
      variant: Experiments.PACKAGES_ENABLED.variants.available,
    },
    {
      id: Experiments.TRIPS_ENABLED.name,
      variant: Experiments.TRIPS_ENABLED.variants.available,
    },
    {
      id: Experiments.HOMEPAGE_BANNER.name,
      variant: Experiments.HOMEPAGE_BANNER.variants.control,
    },
    {
      id: Experiments.SEATS_ENABLED.name,
      variant: Experiments.SEATS_ENABLED.variants.available,
    },
    {
      id: Experiments.EXCHANGE_ENABLED.name,
      variant: Experiments.EXCHANGE_ENABLED.variants.control,
    },
    {
      id: Experiments.RBC_ALLIANZ_INSURANCE_ENABLED.name,
      variant: Experiments.RBC_ALLIANZ_INSURANCE_ENABLED.variants.available,
    },
    {
      id: Experiments.FILTER_UNAVAILABLE_LODGINGS.name,
      variant: Experiments.FILTER_UNAVAILABLE_LODGINGS.variants.control,
    },
    {
      id: Experiments.RBC_ENABLE_PRICE_PREDICTION.name,
      variant: Experiments.RBC_ENABLE_PRICE_PREDICTION.variants.available,
    },
    {
      id: Experiments.AIRCANADA_PORTER_SHOW_ALL_GRID_FARES.name,
      variant:
        Experiments.AIRCANADA_PORTER_SHOW_ALL_GRID_FARES.variants.control,
    },
    {
      id: Experiments.MAINTENANCE_PAGE_ENABLED.name,
      variant: Experiments.MAINTENANCE_PAGE_ENABLED.variants.control,
    },
    {
      id: Experiments.LODGING_CANCEL_V2.name,
      variant: Experiments.LODGING_CANCEL_V2.variants.control,
    },
    {
      id: Experiments.AVION_EARN_SUMMARY.name,
      variant: Experiments.AVION_EARN_SUMMARY.variants.control,
    },
    {
      id: Experiments.UPSELL_STAYS_FROM_FLIGHTS.name,
      variant: Experiments.UPSELL_STAYS_FROM_FLIGHTS.variants.inline,
    },
    {
      id: Experiments.HTS_MEDIA.name,
      variant: Experiments.HTS_MEDIA.variants.control,
    },
  ],
  trackingProperties: {},
});
